import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Divider } from 'primereact/divider';
import { getAuthData, isAdmin } from '../../service/auth';
 

import styles from './styles.module.css';
import api from '../../service/api';

export default function ChangeDefaultPassword() {

    const [confirmPassword, setConfirmPassword] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const toast = useRef(null);
    const history = useHistory();
    const authData = getAuthData();
    const isadmin = isAdmin();

    const handleWithChangePassword = () => {
        if(confirmPassword === '' || password === '')
            return toast.current.show({severity: 'error', summary: 'Atenção', detail: 'Preencha as senhas!'});
        
        if(confirmPassword !== password) 
            return toast.current.show({severity: 'error', summary: 'Atenção', detail: 'As senhas são diferentes!'});

        if(password.replace(/\D/g, '') === '') 
            return toast.current.show({severity: 'error', summary: 'Atenção', detail: 'A senha deve possuir ao menos 1 número!'});

        if(password.replace(/[a-z]|\d|\W/g, '') === '') 
            return toast.current.show({severity: 'error', summary: 'Atenção', detail: 'A senha deve possuir ao menos 1 letra maiúscula!'});

        if(password.replace(/\w/g, '') === '') 
            return toast.current.show({severity: 'error', summary: 'Atenção', detail: 'A senha deve possuir ao menos 1 caracter especial (@,!,?,-,*,$, &)'});
       
        if(password.length < 8) 
            return toast.current.show({severity: 'error', summary: 'Atenção', detail: 'A senha deve possuir no mínimo 8 caracteres!'});

        setLoading(true);
        api().post('/users/change/default/password', { password, code: authData.user.code }).then(response => {
            if(response.status === 200 && response.data.result){
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: 'Senha alterada com sucesso. Você será redirecionado, aguarde...', time: 4000});
                setTimeout(() => {
                    if(isadmin) return history.push('/dashboard');
                    return history.push('/travel');
                }, 3000);
            } else {
                setLoading(false);
                return toast.current.show({
                    severity: 'error', summary: 'Atenção', 
                    detail: (response.data.message || 'Não foi possível alterar a senha!')
                });
            }
        }).catch(error => {
            setLoading(false);
            return toast.current.show({severity: 'error', summary: 'Atenção', detail: 'Não foi possível alterar a senha!'});
        });
    }

    const header = () => {
        return(
            <div className={styles.contentHeader}>
                <h3>ALTERAR SENHA</h3>
            </div>
        )
    }

    const footer = (
        <React.Fragment>
            <Divider />
            <p className="mt-2">Sugestão</p>
            <ul className="pl-2 ml-2 mt-0" style={{lineHeight: '1.5'}}>
                <li>Ao menos 1 letra maiúscula</li>
                <li>Ao menos 1 número</li>
                <li>Ao menos 1 caracter especial (@,!,?,-,*,$, &)</li>
                <li>No mínimo 8 caracteres</li>
            </ul>
        </React.Fragment>
    );

    return (
        <div className={styles.container}>
            <Toast ref={toast} position="top-right" />
            <Card header={header} className={styles.myCard}>
                <div className={styles.contentForm}>
                    <div>   
                        <label htmlFor="password1" className="block">Informe uma senha</label>
                        <span className={"p-input-icon-left " + styles.w100}>
                            <Password id="password1" 
                                disabled={loading}
                                promptLabel='Sua senha'
                                weakLabel='Fraca'
                                mediumLabel='Média'
                                strongLabel='Forte'
                                autoComplete="off"
                               
                                footer={footer}
                                className={styles.w100}
                                value={password} toggleMask
                                onChange={(e) => setPassword(String(e.target.value || '').replaceAll(' ', ''))} placeholder="Informe sua senha" />
                        </span>
                    </div>

                    <div>   
                        <label htmlFor="password2" className="block">Confirme sua senha</label>
                        <Password id="password2" 
                            disabled={loading}
                            className={styles.w100}
                            feedback={false}
                            value={confirmPassword} toggleMask
                            autoComplete="off"
                            onChange={(e) => setConfirmPassword(String(e.target.value || '').replaceAll(' ', ''))} placeholder="Confirme sua senha" />
                    </div>
                    <div className={styles.buttonForm}>
                        <Button loading={loading} label={loading ? 'Alterando...' : 'Alterar'} className="p-button-rounded" onClick={handleWithChangePassword} />
                    </div>

                </div>
            </Card>
        </div>
    );
}